(function () {
	const toggle = document.querySelector('.menu-toggle');
	const mobileNav = document.querySelector('.mobile-nav');
	if (!toggle || !mobileNav) return;

	toggle.addEventListener('click', function () {
		const isOpen = mobileNav.classList.toggle('mobile-nav--open');
		toggle.classList.toggle('menu-toggle--active', isOpen);
		toggle.setAttribute('aria-expanded', isOpen);
		mobileNav.setAttribute('aria-hidden', !isOpen);
		document.body.style.overflow = isOpen ? 'hidden' : '';
	});

	// Close on link click
	mobileNav.querySelectorAll('a').forEach(function (link) {
		link.addEventListener('click', function () {
			mobileNav.classList.remove('mobile-nav--open');
			toggle.classList.remove('menu-toggle--active');
			toggle.setAttribute('aria-expanded', 'false');
			mobileNav.setAttribute('aria-hidden', 'true');
			document.body.style.overflow = '';
		});
	});
})();
